<div class="template-container">
  <img #signaturePlacementPreview
       *ngIf="signaturePlacementImageDataUri"
       [src]="signaturePlacementImageDataUri"
       alt=""
       aria-hidden="true"
       class="signature-placement-preview"
       draggable="false">
  <div *ngIf="insertFieldEnabled" class="box card-box side-panel light">
    <div class="box-header">
      <h3 class="text-ellipsis text-accent">{{ 'TEMPLATE.insert_field' | translate }}</h3>
    </div>
    <ul class="nav nav-tabs insert-field-tabs" role="tablist">
      <li class="nav-item">
        <a (click)="selectInsertFieldTab('fields')"
           (keydown.enter)="selectInsertFieldTab('fields')"
           [attr.aria-selected]="insertFieldTab === 'fields'"
           [class.active]="insertFieldTab === 'fields'"
           class="nav-link pointer"
           role="tab"
           tabindex="0"
           test-id="insertFieldTabFields">
          {{ 'TEMPLATE.insert_field_tab_fields' | translate }}
        </a>
      </li>
      <li *ngIf="fieldReviewRows.length" class="nav-item">
        <a (click)="selectInsertFieldTab('placeholders')"
           (keydown.enter)="selectInsertFieldTab('placeholders')"
           [attr.aria-selected]="insertFieldTab === 'placeholders'"
           [class.active]="insertFieldTab === 'placeholders'"
           class="nav-link pointer"
           role="tab"
           tabindex="0"
           test-id="insertFieldTabPlaceholders">
          {{ 'TEMPLATE.insert_field_tab_placeholders' | translate }}
          <span test-id="placeholdersCount">({{ fieldReviewRows.length }})</span>
        </a>
      </li>
    </ul>
    <div [hidden]="insertFieldTab !== 'fields'" class="box-body">
      <input [formControl]="filterControl"
             class="form-control"
             placeholder="{{ 'NAVBAR.search' | translate }}..."
             type="text"/>
      <div class="tree-height">
        <ejs-treeview #treeViewObj
                      (nodeSelecting)="onMergeFieldNodeSelecting($event)"
                      [fields]="treeViewFields"
                      class="tree-view-height">
        </ejs-treeview>
      </div>

    </div>
    <div *ngIf="insertFieldTab === 'placeholders'" class="box-body placeholders-body">
      <gp-placeholders-tab (apply)="applyFieldReview($event)"
                           (locate)="locatePlaceholder($event)"
                           (matchWithAi)="matchWithAi()"
                           (refresh)="refreshFromDocument()"
                           (rowsChange)="onReviewRowsChange($event)"
                           [canMatch]="!!eTemplateData?.cliRegId"
                           [fieldTree]="fieldListTreeForInsertFields"
                           [rows]="fieldReviewRows"
                           [state]="fieldReviewState">
      </gp-placeholders-tab>
    </div>
  </div>
  <gp-template-signature-panel *ngIf="insertSignatureEnabled"
                               (closePanel)="closeInsertSignaturePanel()"
                               (insertSignature)="startSignaturePlacement($event)"
                               (removeSignatures)="removeSignatureImagesFromDocument($event)"
                               (signatureDataChange)="persistSignatureDataOnTemplate($event)"
                               [cliRegId]="signatureCliRegId"
                               [countSignaturesInDocument]="signatureCounter"
                               [documentChangeCounter]="documentChangeCounter"
                               [signatureData]="signatureData">
  </gp-template-signature-panel>
  <div [class.main-panel--split]="insertFieldEnabled || insertSignatureEnabled" class="box card-box shadow main-panel">
    <div *ngIf="showHeader" class="box-header">
      <div class="col-md-2 col-sm-3 p-a-0">
        <gp-back-link
          (linkClick)="backToList()"
          [linkText]="'TEMPLATE.view_all_templates'"
          class="block text-ellipsis">
        </gp-back-link>
      </div>
      <div class="col-md-4 col-sm-6 p-a-0 text-center">
        <h3 class="text-ellipsis" [title]="eTemplateData?.name">{{eTemplateData?.name}}</h3>
      </div>
      <div *ngIf="eTemplateData"
           [class.flex-wrap]="insertFieldEnabled || insertSignatureEnabled"
           class="col-md-6 col-sm-3 p-a-0 flex align-items-center flex-end">
        <div class="m-x-xs m-t-xs flex">
          <span>{{"TEMPLATE.autoSave" | translate}}</span>
          <label class="ui-switch m-l-xs">
            <input (change)="onChangeAutoSave($event.target)" [(ngModel)]="autoSave" id="autoSave"
                   type="checkbox"/>
            <em></em>
          </label>
        </div>

        <button (click)="openAiGenerateModal()"
                tooltip="{{ 'TEMPLATE.ai_generate_title' | translate }}"
                class="btn btn-primary btn-sm m-x-xs m-t-xs flex"
                test-id="btnAiGenerate">
          <i class="fa fa-light fa-wand-magic-sparkles"></i>
        </button>

        <button (click)="handleFileExport(eTemplateData?.name)"
                tooltip="{{ 'REPORTS.export' | translate }}"
                class="btn btn-primary btn-sm m-x-xs m-t-xs flex"
                test-id="btnExportFile">
          <i class="fa fa-light fa-download"></i>
        </button>

        <button (click)="handlePreviewTemplate()"
                class="btn btn-primary btn-sm m-x-xs m-t-xs"
                test-id="btnPreviewTemplate">
          {{ 'REPORTS.preview' | translate }}
        </button>

        <div [userRoles]="['EGEN_DOC_WRITE']" gp-roles>
          <button (click)="saveTemplate(true)"
                  [disabled]="!editorIsDirty"
                  test-id="btnSaveAndClose"
                  class="btn btn-primary btn-sm pull-right m-r-xs m-t-xs">
            <span *ngIf="savingAndClosing"><em class="fa fa-light fa-spinner fa-spin"></em></span>
            <span *ngIf="!savingAndClosing">{{ 'TEMPLATE.save_and_close' | translate }}</span>
          </button>
          <button (click)="saveTemplate(false)"
                  [disabled]="!editorIsDirty"
                  test-id="btnSave"
                  class="btn btn-primary btn-sm pull-right m-r-xs m-t-xs">
            <span *ngIf="saving"><em class="fa fa-light fa-spinner fa-spin"></em></span>
            <span *ngIf="!saving">{{ 'FORMS.save' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
    <div class="box-body">
      <div *ngIf="loading" class="padding">
        <em class="fa fa-light fa-spinner fa-spin"></em>
      </div>
      <gp-illustrated-message *ngIf="!loading && !eTemplateData"
                              [text]="'COMMON.something_went_wrong'"
                              [type]="'SOMETHING_WRONG'">
      </gp-illustrated-message>
      <ejs-documenteditorcontainer #editorPreview
                                   *ngIf="!loading && eTemplateData"
                                   (click)="placePendingSignature($event)"
                                   (created)="onEditorPreviewCreated()"
                                   (mousedown)="removeUnsupportedImageMoveCursor($event)"
                                   (mousemove)="removeUnsupportedImageMoveCursor($event)"
                                   (toolbarClick)="onToolBarButtonClicked($event)"
                                   (contentChange)="onEditorContentChange()"
                                   (documentChange)="onDocumentChange()"
                                   [enableToolbar]=true
                                   [enableLocalPaste]=false
                                   [documentEditorSettings]="documentEditorSettings"
                                   [locale]="documentEditorLocale"
                                   [showPropertiesPane]="showPropertiesPane"
                                   [serviceUrl]="templateManagementService.serviceUrl"
                                   [headers]="templateManagementService.getToken$ | async"
                                   height="100%"
                                   width="100%">
      </ejs-documenteditorcontainer>
    </div>
  </div>
</div>
